import React, { useContext, useState } from 'react';
import { store } from './Driver';
// import { store as mainStore } from '../../../../../../store';
// import { DataGrid } from '@material-ui/data-grid';
import Skeleton from '@material-ui/lab/Skeleton';
import { localText } from '../../../../../../langs/fa/data-grid';
import moment from 'moment-jalaali';
import { __ } from '../../../../../../utils/i18n';
import { useHistory, useParams } from 'react-router-dom';
import NoOrders from './NoOrders';
import { formatNumber } from 'fns';
import DataGrid from 'components/DataGrid/DataGrid';
import { useMediaQuery } from '@material-ui/core';

const OrdersList = () => {
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const { state, dispatch } = useContext(store);
  const { fetchingOrders } = state;
  const { orders } = state;
  // const { state: mainState } = useContext(mainStore);
  // const { itemsCountPerPage } = mainState.Props;
  const isMobile = useMediaQuery('(max-width:1350px)');

  const columns = [
    {
      field: 'loadDate',
      headerName: 'بارگیری',
      width: 100,
      renderCell: ({ value }) => value,
    },
    // { field: 'origin', headerName: 'مبدا', width: 100 },
    // { field: 'fleetOptions', headerName: 'ناوگان', flex: 1 },
    // { field: 'fleetCount', headerName: 'تعداد', width: 100 },
    {
      field: 'destination',
      headerName: 'مقصد',
      flex: 1,
      cellClassName: ({ value: { status } }) => status,
    },
    // { field: 'loadTime', headerName: 'زمان', flex: 1 },
    {
      field: 'loadType',
      headerName: 'محموله',
      width: 120,
      headerClassName: 'colHeader',
    },
    // { field: 'packaging', headerName: 'بسته‌بندی', width: 120 },
    {
      field: 'commissionDeduction',
      headerName: 'کاهش‌کمیسیون',
      flex: 1,
      renderCell: ({ value }) => (
        <span style={{ fontWeight: 'bold', color: 'red' }}>
          {value?.commissionDeduction
            ? formatNumber(value.commissionDeduction)
            : ''}
        </span>
      ),
    },
    {
      field: 'commission',
      headerName: 'کمیسیون‌پرداختی',
      flex: 1,
      renderCell: ({ value }) => (
        <span style={{ fontWeight: 'bold', color: 'green' }}>
          {value?.totalCommission > 0
            ? formatNumber(value.totalCommission)
            : ''}
        </span>
      ),
    },
    { field: 'orderStatus', headerName: 'وضعیت', width: 130 },
  ];
  const history = useHistory();

  const handlePageChange = async ({ page }) => {
    if (orders.page === page) return;
    setLoading(true);
    const res = await fetchingOrders(id, page, orders.limit);
    setLoading(false);
    dispatch({ type: 'LOAD', payload: { name: 'orders', value: res } });
  };

  const handleSelectOrder = (order) => {
    history.push(`/protected/admin/orders/${order.row.id}`);
  };
  return (
    <>
      <h4>بارگیری‌ها:</h4>
      <div
        style={{
          height: isMobile ? 400 : 300,
          marginBottom: isMobile ? 100 : 0,
          overflowY: isMobile ? 'auto' : 'unset',
          width: '100%',
        }}
      >
        {orders ? (
          <DataGrid
            rows={
              orders && orders.docs
                ? orders.docs.map((o) => ({
                    id: o._id,
                    loadDate: o?.loadDate
                      ? moment(o.loadDate).format('jMM/jDD')
                      : '',
                    destination: o.destination.title,
                    loadType: o.cargos[0].type.title,
                    commission: o,
                    commissionDeduction: o,
                    orderStatus: __(o.status),
                  }))
                : []
            }
            columns={columns}
            localeText={localText}
            pageSize={orders && orders.limit ? orders.limit : 0}
            rowCount={orders && orders.totalDocs ? orders.totalDocs : 0}
            paginationMode="server"
            onPageChange={handlePageChange}
            loading={loading}
            disableMultipleSelection
            density="compact"
            components={{
              noRowsOverlay: NoOrders,
            }}
            onCellClick={handleSelectOrder}
          />
        ) : (
          <Skeleton height={300} variant="rect" animation="wave" />
        )}
      </div>
    </>
  );
};

export default React.memo(OrdersList);
